import type { ChangeEvent, FormEvent } from 'react';
import { useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { useNavigate } from 'react-router-dom';

import { ERROR_TEXT_SX, ErrorPage, ErrorPageAction } from "../components/errors/ErrorPage";
import { SEARCH_PARAM } from "./WorkoutsPage";

export default function Page404() {
    const navigate = useNavigate();
    const [ query, setQuery ] = useState('');

    function handleSearch(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();
        navigate(query.trim() ? `/workouts?${ SEARCH_PARAM }=${ encodeURIComponent(query.trim()) }` : '/workouts');
    }

    return (
        <ErrorPage code={ 404 } title="This page wandered off" tabTitle="Page Not Found"
                   illustration={ { src: '/assets/images/illustrations/not-found.svg', alt: 'Two robots by a hole in the floor, one reading a map' } }>
            <Typography sx={ ERROR_TEXT_SX }>The link may be old, or the page has moved. Your progress is safe.</Typography>

            <Stack component="form" role="search" direction="row" gap={ 1.25 } onSubmit={ handleSearch }>
                <Box component="label" htmlFor="not-found-search" sx={ visuallyHidden }>Search topics</Box>
                <Box component="input" id="not-found-search" type="search" placeholder="Search Java, SQL, Kafka…" value={ query }
                     onChange={ (event: ChangeEvent<HTMLInputElement>) => setQuery(event.target.value) } sx={ {
                    flexGrow: 1, minWidth: 0, height: 44, boxSizing: 'border-box', border: '1px solid #CFD6DE', borderRadius: '10px', px: 1.75,
                    font: 'inherit', fontSize: 14, bgcolor: '#FFFFFF', '&:focus': { outline: '2px solid #2065D1', outlineOffset: 1 },
                } }/>
                <Box component="button" type="submit" sx={ {
                    height: 44, px: 2.25, borderRadius: '10px', border: '1px solid #CFD6DE', bgcolor: '#FFFFFF', font: 'inherit', fontSize: 14,
                    fontWeight: 700, color: '#161C24', cursor: 'pointer', '&:focus-visible': { outline: '2px solid #2065D1', outlineOffset: 2 },
                } }>
                    Search
                </Box>
            </Stack>

            <Stack direction="row" flexWrap="wrap" gap={ 1.5 } sx={ { pt: 0.5 } }>
                <ErrorPageAction to="/workouts" primary>Back to Workouts</ErrorPageAction>
                <ErrorPageAction to="/dashboard">Open dashboard</ErrorPageAction>
            </Stack>
        </ErrorPage>
    );
}
